import { useState } from "react";
import styles from "./../styles.module.css";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../../../model/PlanoDeTrabalho/CronogramaExecucao";
import Modal from "react-responsive-modal";
import Table from "../../../../components/TableConstructor";
import RowAplicacao from "../../../../components/TableConstructor/Row/RowAplicacao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  aplicacoesCorrente: MetaAplicacao[];
  aplicacoesCapital: MetaAplicacao[];
  listaMetas: MetaFisica[];
};

function AplicacaoFinanceira({
  passarPagina,
  voltarPagina,
  aplicacoesCorrente,
  aplicacoesCapital,
  listaMetas,
}: Props) {
  const [showModelCorrente, setModelCorrente] = useState(false);
  const [showModelCapital, setModelCapital] = useState(false);
  const [showEditModelCorrente, setEditModalCorrente] = useState(-1);
  const [showEditModelCapital, setEditModalCapital] = useState(-1);
  return (
    <div>
      <h2 className={styles.titulo}>
        2.2. Cronograma de Aplicação Financeira :
      </h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Corrente:</h3>
      <div>
        <Table
          listTitle={[
            "Meta",
            "Especificação - CORRENTE",
            "Órgão/Entidade ",
            "OSC",
            "",
          ]}
          styleList={[1, 0, 1, 1, 0]}
        >
          {aplicacoesCorrente.map((appObj, index) => (
            <RowAplicacao
              appObj={appObj}
              key={index}
              metaFisica={listaMetas[appObj.meta_execucao_fisico_id]}
            ></RowAplicacao>
          ))}
        </Table>
        <Modal
          open={showModelCorrente}
          onClose={() => setModelCorrente(false)}
          center
          classNames={{
            modal: "customModal",
          }}
        ></Modal>
      </div>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Capital:</h3>
      <div>
        <Table
          listTitle={[
            "Meta",
            "Especificação - CAPITAL",
            "Órgão/Entidade",
            "OSC",
            "",
          ]}
          styleList={[1, 0, 1, 1, 0]}
        >
          {aplicacoesCapital.map((appObj, index) => (
            <RowAplicacao
              appObj={appObj}
              key={index}
              metaFisica={listaMetas[appObj.meta_execucao_fisico_id]}
            ></RowAplicacao>
          ))}
        </Table>
      </div>
      <Modal
        open={showModelCapital}
        onClose={() => setModelCapital(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      ></Modal>
      <hr className={styles.separador} />
      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default AplicacaoFinanceira;
